import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { actions } from '../../../../store'
import LicensesManager from './LicensesManager'

const mapStateToProps = state => ({
  division: state.division
})

const mapDispatchToProps = dispatch => bindActionCreators({
  getDivisions: actions.division.getDivisions
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LicensesManager)



// WEBPACK FOOTER //
// ./src/views/Users/components/LicensesManager/index.js